import styled from "styled-components";
import welcome_background from '../../../assets/welcome-background.png';
import Carousel from 'react-multi-carousel';

export const ProfileContainer = styled.main`
  width: 100%;
  position: relative;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  @media (max-width: 991px) {
    padding: 0 20px;
    justify-content: space-between;
  }
`;

export const ProfileImage = styled.img`
  aspect-ratio: 4;
  object-fit: cover;
  width: 260px;
  max-width: 100%;
  margin-top: 20px;
  cursor: pointer;
  @media (max-width: 991px) {
    width: 100px;
    margin-top: 10px;
  }
`;

export const Hamburger = styled.div`
  display: none;
  @media (max-width: 991px) {
    display: block;
    cursor: pointer;
  }
`;

export const HamburgerImg = styled.img`
  width: 30px;
  height: 30px;
`;

export const Nav = styled.nav`
  display: flex;
  margin-top: 24px;
  gap: 20px;
  font-size: 16px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  line-height: 130%;
  justify-content: space-between;
  @media (max-width: 991px) {
    flex-direction: column;
    position: absolute;
    right: 0;
    margin-top: -20px;
    background-color: white;
    width: 60%;
    gap: 10px;
    justify-content: start;
    border-left: 1px solid #202023;
    height: 100vh;
    display: ${props => (props.$isOpen ? 'flex' : 'none')};
    background-color: ${props => (props.$isActive ? "#e9fe53" : "white")};
    z-index: 1000;
  }
`;

export const NavItem = styled.span`
  font-family: Metrophobic, sans-serif;
  background-color: ${props => (props.$isActive ? "#e9fe53" : "transparent")};
  justify-content: center;
  cursor: pointer;
  @media (max-width: 991px) {
    white-space: initial;
    padding: 5px 20px;
    background-color: ${props => (props.$isActive ? "white" : "transparent")};
  }
`;

export const CloseButton = styled.button`
  @media (max-width: 991px) {
    font-family: Metrophobic, sans-serif;
    align-self: flex-end;
    background: none;
    border: none;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 20px;
    margin-top: 20px;
    margin-right: 20px;
  }
`;

export const NavigationLinks = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  font: 400 21px Metrophobic, sans-serif;
  align-self: flex-start;
  gap: 20px;
  width: 100%;
  @media (max-width: 991px) {
    font: 600 16px Metrophobic, sans-serif;
    align-self: center;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
  }
`;

export const Link = styled.span`
  color: #fff;
  cursor: pointer;
`;

export const DesktopOnlyLink = styled.span`
  color: #fff;
  cursor: pointer;
  display: inline;
  @media (max-width: 991px) {
    display: none;
  }
`;

export const MobileOnlyLink = styled.span`
  color: #fff;
  cursor: pointer;
  display: none;
  @media (max-width: 991px) {
    display: inline;
  }
`;

export const SocialSection = styled.section`
  align-self: stretch;
  display: flex;
  margin-top: 20px;
  width: 100%;
  gap: 20px;
  font-size: 12px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }
`;

export const SocialLink = styled.div`
  display: flex;
  gap: 5px;
  white-space: nowrap;
  @media (max-width: 991px) {
    white-space: initial;
    justify-content: center;
    align-self: center;
  }
`;
export const HelpLink = styled.div`
  display: flex;
  gap: 35px;
  white-space: nowrap;
  @media (max-width: 991px) {
    white-space: initial;
    justify-content: center;
    align-self: center;
  }
`;
export const SocialLabel = styled.div`
  font-family: Metrophobic, sans-serif;
  text-transform: uppercase;
  color: #fff;
`;

export const SocialIcon = styled.img`
  aspect-ratio: 1;
  object-fit: cover;
  width: 12px;
  margin: auto 0;
  filter: invert(1);
`;

export const SocialText = styled.div`
  font-family: Metrophobic, sans-serif;
  color: #fff;
`;

export const Footer = styled.footer`
  color: #fff;
  font-family: Metrophobic, sans-serif;
  flex-grow: 1;
  text-align: right;
  margin-top: auto;
  opacity: 0.7;
  @media (max-width: 991px) {
    text-align: center;
    align-self: center;
  }
`;

export const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #000;
  color: #fff;
  padding: 60px 80px;
  box-sizing: border-box;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 991px) {
    padding: 40px 20px;
  }
`;

export const MainContent = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.$bgColor || '#fff'};
  transition: background-color 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 100vh;
  padding: ${props => props.$noPadding ? '0 0 36px' : props.$reducedPadding ? '60px 40px 36px' : '60px 80px 36px'};
  box-sizing: border-box;
  box-shadow: 0 20px 50px rgba(0,0,0,0.15);
  margin-bottom: 250px; /* revelations space */
  @media (max-width: 991px) {
    padding: ${props => props.$noPadding ? '0' : props.$reducedPadding ? '10px' : '20px'};
    margin-bottom: 300px;
  }
`;

export const Container = styled.main`
  margin-top: 46px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }
`;

export const Section = styled.section`
  flex: 1;
`;

export const SectionContent = styled.div`
  border: 1px solid #202023;
  padding: 35px 80px 35px 36px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 16px;
  color: #202023;
  font-weight: 400;
  letter-spacing: -0.32px;
  line-height: 130%;
  height: ${props => (props.profile && props.profile.pincode ? '180px' : '295px')};
  width: 65%;
  @media (max-width: 991px) {
    margin-top: 12px;
    width: 200px;
    padding: 20px;
    line-height: 100%;
  }
`;

export const SectionTitle = styled.div`
  font: 800 24px Inter, sans-serif;
  letter-spacing: -0.48px;
  margin-bottom: 17px;
`;

export const ProfileItem = styled.div`
  font-family: Metrophobic, sans-serif;
  letter-spacing: -0.32px;
  margin-top: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:first-of-type {
    margin-top: 0;
  }
`;

export const EditButton = styled.button`
  border: 1px solid #202023;
  background-color: #e9fe53;
  align-self: flex-end;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 400 12px Metrophobic, sans-serif;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  line-height: 130%;
  flex-grow: 1;
  flex-basis: 0;
  width: fit-content;
`;

export const Label = styled.label`
  font-family: Metrophobic, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
    padding: 0;
  }
  max-width: 100%;
`;

export const Input = styled.input`
  padding-left: 10px;
  padding-right: 10px;
  font: 16px/130% Metrophobic, sans-serif;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  margin-top: 10px;
`;

export const SaveButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width: 260px;  
  text-transform: uppercase;
  @media (max-width: 991px) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const ButtonIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
  margin: auto 0;
`;

export const ModalContent = styled.div`
  background-color: white;
  background-image: url(${welcome_background}); 
  background-size: cover; 
  background-position: bottom; 
  margin-top: 160px;
  margin-left: 20%;
  margin-right: 20%;
  padding-top: 50px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  outline: none;
  text-align: center;
  align-items: center;
  position: relative; 
  @media (max-width: 991px) {
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 140px;
  }
`;

export const CloseButtonModal = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  color: #202023;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-top: 30px;
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ProductCard = styled.div`
  border: 1px solid #202023;
  padding: 20px;
  position: relative;
  background-color: #f6f5f8;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 4px;
`;

export const ProductTitle = styled.h3`
  font-size: 14px;
  margin: 10px 0;
  font-weight: 600;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
`;

export const CurrentPrice = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

export const ShareButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  background-color: #e9fe53;
  height: 40px;
  margin-top: 40px;
  margin-bottom: 20px;
  width: 50%;
  max-width: 100%;
  gap: 8px;
  font-size: 16px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  line-height: 130%;
  @media (max-width: 991px) {
    padding: 10px;
    white-space: normal;
    margin-bottom: 20px;
    height: auto;
    width: 80%;
    font-size: 14px;
  }
`;

export const BrandsCarousel = styled(Carousel)`
  .react-multi-carousel-track {
    align-items: center;
  }
`;
export const EditText = styled.div`
  margin-top: 10px;
  input {
    margin: 5px 0;
    padding: 10px;
    width: 100%;
  }
  button {
    margin-top: 10px;
    padding: 10px;
    background-color: #e9fe53;
    border: none;
    cursor: pointer;
  }
`;
// Many more styled components from the original file...
// Continue adding all the styled components from the original file as needed 